import { Pipe, PipeTransform } from '@angular/core';

type SelectItem = string | number | Record<string, unknown>;

@Pipe({
  name: 'selectItemField',
  pure: true,
})
export class SelectItemFieldPipe implements PipeTransform {
  transform(item: SelectItem, field?: string): unknown {
    return field && typeof item === 'object' && item !== null
      ? item[field]
      : item;
  }
}

